class CalendarSettings {
  public getLanguage() {
    const html = document.querySelector('html') as HTMLElement
    const currentLanguage = html.getAttribute('lang')

    return currentLanguage || 'pl-PL'
  }
}

export default CalendarSettings
